import BalanceHistory from '../../models/balances/balance-history';
import AccountingApiClient from './base-client';

class BalanceHistoryApi extends AccountingApiClient<
  BalanceHistory,
  BalanceHistory
> {
  public constructor() {
    super('/balance-history');
  }

  public get = async (): Promise<BalanceHistory> => {
    return super.httpGet(this.baseUrl);
  };
}

const balanceHistoryApi = new BalanceHistoryApi();

export default balanceHistoryApi;
